export default __webpack_public_path__ + "images/Bakery.decd00.jpg";